import React, {useEffect, useState} from 'react';
import {FormattedMessage} from 'react-intl';
import {VAT} from '../../../../../utils';
import styles from './styles.module.scss';

interface SummaryDetailsUnitProps {
  lines: {amount: number | string, vatIncluded: boolean}[],
  date: Date,
}

const SummaryDetailsUnit = ({lines, date}: SummaryDetailsUnitProps) => {
  const [amountSum, setAmountSum] = useState('0');
  const [vatSum, setVatSum] = useState('0');
  const [totalAmountSum, setTotalAmountSum] = useState('0');

  useEffect(() => {
    const arraySum = lines
      .map(summaryData => {
        const amount = (typeof summaryData.amount === 'string') ? parseFloat(summaryData.amount) : summaryData.amount;
        return (summaryData.vatIncluded)
          ? amount / (1 + VAT.fraction(date))
          : amount;
      })
      .filter(Boolean)
      .reduce((acc, item) => acc + item, 0);

    setAmountSum(arraySum.toFixed(2));
    setVatSum((arraySum * VAT.fraction(date)).toFixed(2));
    setTotalAmountSum((arraySum * (1 + VAT.fraction(date))).toFixed(2));
  }, [lines]);

  return (
    <div className={styles.summaryUnit}>
      <div className={styles.item}>
        <div className={styles.label}>
          <FormattedMessage id="invoice-orders-popup-edit-total" defaultMessage="Total"/>
        </div>
        <div
          dir="ltr"
          className="bg-light font-weight-bold form-control d-flex justify-content-end align-items-center px-2 py-0 w-140px h-30px">
          {amountSum}
        </div>
      </div>
      <div className={styles.item}>
        <div className={styles.label}>
          <FormattedMessage id="invoice-orders-popup-edit-vat" defaultMessage="vat" values={{vatPercents: VAT.toString(date)}}/>
        </div>
        <div
          dir="ltr"
          className="bg-light font-weight-bold form-control d-flex justify-content-end align-items-center px-2 py-0 w-140px h-30px">
          {vatSum}
        </div>
      </div>
      <div className={styles.item}>
        <div className={styles.label}>
          <FormattedMessage id="invoice-orders-popup-edit-amount" defaultMessage="Amount"/>
        </div>
        <div
          dir="ltr"
          className="bg-light font-weight-bold form-control d-flex justify-content-end align-items-center px-2 py-0 w-140px h-30px">
          {totalAmountSum}
        </div>
      </div>
    </div>
  );
};

SummaryDetailsUnit.propTypes = {};

export default SummaryDetailsUnit;
